import MailingList, { MailingListProps } from "./MailingList";
import MailingListV2 from "./MailingListV2";

export { MailingList, MailingListProps };
export { MailingListV2 };

export default MailingList;
